import React from 'react';
import { SeparatorLine } from '../../../../components/SeparatorLine/SeparatorLine';
import { extractRange } from '../../../../helpers/dateTimes';
import { useLanguage } from '../../../../locale/useLanguage';
import { Product } from '../../../../models';
import { PurchaseItem } from '../../../../models/payment.models';
import { TransactionSection } from '../TransactionSection/TransactionSection';

import './ProductItem.css';

type ProductItemProps = {
  purchaseItem: PurchaseItem;
};

export const ProductItem: React.FC<ProductItemProps> = ({ purchaseItem }) => {
  const [t] = useLanguage();

  const isAppointment = purchaseItem.product === Product.Appointment;
  let firstValue: string;
  let secondValue: string;

  const productName = isAppointment
    ? t('orderDetails.appointment')
    : t('orderDetails.pdr');

  const firstLabel = isAppointment
    ? t('orderDetails.appointmentDate')
    : t('orderDetails.pdrName');

  const secondLabel = isAppointment
    ? t('orderDetails.appointmentTimeSlot')
    : t('orderDetails.pdrAddress');

  if (isAppointment) {
    const timeRange = extractRange(purchaseItem.configuration.timeRange);
    firstValue = timeRange.from.format('DD MMMM YYYY');
  } else {
    firstValue = purchaseItem.configuration.pdr!.name;
  }

  if (isAppointment) {
    const timeRange = extractRange(purchaseItem.configuration.timeRange);
    secondValue = `${timeRange.from.format('HH:mm')} - ${timeRange.to.format(
      'HH:mm'
    )}`;
  } else {
    secondValue = purchaseItem.configuration.pdr!.indirizzo;
  }

  return (
    <>
      <div className="order-details--info-container">
        <p className="order-details--title">{productName}</p>
        <p className="order-details--text">
          {firstLabel}: {firstValue}
        </p>
        <div className="order-details--price-line">
          <p className="order-details--text">
            {secondLabel}: {secondValue}
          </p>
          <p className="order-details--price">
            € {purchaseItem.price.toFixed(2)}{' '}
            {purchaseItem.originalPrice !== purchaseItem.price && (
              <small className="order-details--sale-price">
                € {purchaseItem.originalPrice.toFixed(2)}
              </small>
            )}
          </p>
        </div>
        <TransactionSection purchaseItem={purchaseItem} />
      </div>
      <SeparatorLine />
    </>
  );
};
